export const ChevronsLeft = (props : any) => <svg  width="16" height="16" {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g opacity="0.4">
    <path d="M7.33333 11.3333L4 7.99999L7.33333 4.66666M12 11.3333L8.66667 7.99999L12 4.66666" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </g>
</svg>
